import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { ExampleArrow } from "./resources/example-grid"
import Markdown from "react-markdown"
import supersub from "remark-supersub"
import media from "../styles/media"
import theme from "../styles/theme"
import { useBanner } from "@hooks/use-banner"
import { isExternal } from "@utils/is-external"
import PropTypes from "prop-types"

const StyledBanner = styled.div`
  display: flex;
  background: linear-gradient(
    90deg,
    ${theme.color.indigo700},
    ${theme.color.indigo500},
    ${theme.color.indigo700}
  );
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  height: 46px;
  z-index: 100;

  .prose {
    color: white;
    font-size: 0.875rem;
    * {
      margin: 0;
    }
  }

  ${ExampleArrow} {
    margin-left: -0.5rem;
  }

  :hover ${ExampleArrow} {
    transform: translateX(8px);
  }

  ${media.md`
    display: none;
  `}
`

const LayoutBannerContents = ({ content }) => {
  return (
    <>
      <svg
        width="20px"
        height="20px"
        version="1.1"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="white"
          d="m31.25 64.344h17.531l-11.094 25c-0.55469 1.2422-1.7656 2.0664-3.125 2.125h-9.7812c-1.2578 0.027344-2.4414-0.59766-3.125-1.6562-0.70703-1.0195-0.82422-2.3398-0.3125-3.4688zm4.1562-33.844h-25.5c-0.96875-0.007812-1.8984 0.37109-2.582 1.0508-0.6875 0.67969-1.0742 1.6055-1.0742 2.5742v19.281c0.015625 2.0078 1.6484 3.625 3.6562 3.625h25.5zm53.531-18.75c-9.375 6.0625-30.844 18.75-43.75 18.75h-2.4062v26.531h7.2188c10.5 0 30.344 9.625 39.25 14.281 0.96484 0.47266 2.1055 0.41797 3.0195-0.14844 0.91406-0.5625 1.4727-1.5586 1.4805-2.6328v-54.156c0-1.1406-0.625-2.1914-1.6289-2.7383s-2.2227-0.50391-3.1836 0.11328z"
        />
      </svg>

      <Markdown remarkPlugins={[supersub]} className="prose">
        {content}
      </Markdown>
    </>
  )
}

LayoutBannerContents.propTypes = {
  content: PropTypes.string.isRequired,
}

const LayoutBanner = () => {
  const { banner } = useBanner()

  if (!banner) {
    return
  }

  if (banner.link) {
    const external = isExternal(banner.link)

    return external ? (
      <StyledBanner as="a" href={banner.link}>
        <LayoutBannerContents content={banner.content.content} />
        <ExampleArrow />
      </StyledBanner>
    ) : (
      <StyledBanner as={Link} to={banner.link}>
        <LayoutBannerContents content={banner.content.content} />
        <ExampleArrow />
      </StyledBanner>
    )
  }

  return (
    <StyledBanner>
      <LayoutBannerContents content={banner.content.content} />
    </StyledBanner>
  )
}

export default LayoutBanner
